var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fold_module" }, [
    _c(
      "div",
      {
        ref: "textContainer",
        class: { retract: _vm.status },
        style: { "max-height": _vm.status ? _vm.textHeight : "" }
      },
      [
        _c(
          "div",
          { staticClass: "fold_content" },
          _vm._l(_vm.slotDetail, function(item) {
            return _c("div", { staticClass: "fold_content_item" }, [
              _c("div", { staticClass: "slotDetail" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(item.slotDetailName) +
                    "：\n          " +
                    _vm._s(item.slotDetailDesc) +
                    "\n        "
                )
              ])
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "fold_btn" }, [
          _vm.status
            ? _c(
                "p",
                {
                  staticStyle: { cursor: "pointer" },
                  on: {
                    click: function($event) {
                      _vm.status = false
                    }
                  }
                },
                [_vm._v("展开")]
              )
            : _vm._e()
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "fold_btn", staticStyle: { "margin-top": "-8px" } },
      [
        _vm.status == false
          ? _c(
              "p",
              {
                staticStyle: { cursor: "pointer" },
                on: {
                  click: function($event) {
                    _vm.status = true
                  }
                }
              },
              [_vm._v("收起")]
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }